// src/components/PrivateRoute.jsx
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { auth, authStateReady, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export default function PrivateRoute({ children }) {
  const [user, setUser]       = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    let checkSequence = 0;
    const applyUser = async (u) => {
      const sequence = ++checkSequence;
      if (!active) return;
      setUser(u);
      if (!u) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      try {
        const token = await u.getIdTokenResult();
        if (token.claims?.admin === true || token.claims?.isAdmin === true ||
            token.claims?.owner === true) {
          if (active && sequence === checkSequence) {
            setIsAdmin(true);
            setLoading(false);
          }
          return;
        }
        // Transitional fallback while existing admins are backfilled to claims.
        const snap = await getDoc(doc(db, "admins", u.uid));
        if (active && sequence === checkSequence) setIsAdmin(snap.exists());
      } catch (e) {
        console.warn("Admin check failed:", e);
        if (active && sequence === checkSequence) setIsAdmin(false);
      }
      if (active && sequence === checkSequence) setLoading(false);
    };

    // Reuse the bootstrap observer for the first state. Safari can otherwise
    // miss a second observer callback while restoring local persistence.
    authStateReady.then(applyUser).catch(() => applyUser(auth.currentUser || null));
    const unsubAuth = onAuthStateChanged(auth, applyUser, () => applyUser(auth.currentUser || null));
    return () => {
      active = false;
      unsubAuth();
    };
  }, []);

  if (loading) return <div></div>;
  // If not signed in or not an admin, redirect to login
  if (!user || !isAdmin) return <Navigate to="/login" replace />;

  // Otherwise render the protected children
  return children;
}
